<template>
  <div class="c-card-group">

    <div class="c-card" style="height: 300px;">
      <div style="top: 18px; right: 18px;" class="c-card-right-btn"
        :class="{ 'unclickable disabled-overlay': (!currentUser?.AccountHolder || !accountHolder?.SaasOperator) }">
        <UserDetails source="accountholder" :item="accountHolder" />
      </div>
      <!-- <IconDetails style="top: 18px; right: 18px;" class="c-card-right-btn" /> -->
      <div class="c-card-column-3">
        <div class="c-card-item">
          <div class="c-card-title"><span :class="{ 'disabled-overlay': !currentUser?.AccountHolder }">Account
              Holder</span></div>
          <div class="c-card-content content-type-1">
            <p :class="{ 'disabled-overlay': !currentUser?.AccountHolder }">{{ `${accountHolder?.FirstName ?? "Account"}
              ${accountHolder?.LastName ?? "Holder"}` }}</p>
            <div class="btn-group" v-if="currentUser?.AccountHolder">
              <router-link to="/account" class="nav-link d-flex align-items-center">
                <button type="button" class="btn-outline">Usage</button>
              </router-link>
              <button type="button" @click="openBilling" class="btn-outline"
                :class="{ 'disabled-overlay': !isPaymentMethodAdded }">Billing</button>
                <button type="button" @click="isAccountTransferModal=true" class="btn-outline">Account</button>
            </div>
          </div>
        </div>
        <div class="c-card-item">
          <div class="c-card-title"><span>Admin</span></div>
          <div class="c-card-content content-type-1">
            <ul>
              <li>• Manages Operators</li>
              <li>• Views All Activity</li>
              <li>• Views Analytics</li>
            </ul>
            <div class="switch-group" :class="{ 'disabled-overlay': !currentUser?.AccountHolder }">
              <SwitchLg v-model="accountHolder.SaasAdmin" @update:modelValue="toggleAccountHolderRole(true)" />
            </div>
          </div>
        </div>
        <div class="c-card-item">
          <div class="c-card-title">
            <span :class="{ 'disabled-overlay': !currentUser?.AccountHolder }">Operator</span>
          </div>
          <div class="c-card-content content-type-1">
            <ul :class="{ 'disabled-overlay': !currentUser?.AccountHolder }">
              <li>• Manages Contacts</li>
              <li>• Sets Geofence Messages</li>
              <li>• Views Receiver Activity</li>
            </ul>
            <div class="switch-group" :class="{ 'disabled-overlay': !currentUser?.AccountHolder }">
              <SwitchLg v-model="accountHolder.SaasOperator" @update:modelValue="toggleAccountHolderRole(false)" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="c-card">

      <!-- Settings icon to be enabled later -->
      <!-- <IconSettings @click="showSettingsModal = true" style="top: 18px; right: 22px;" class="c-card-right-btn" /> -->
      <div class="c-card-item">
        <div class="c-card-title">Billed Users</div>
        <div class="c-card-content content-type-2">
          <div class="c-content-row">
            <div>Admin</div>
            <div class="c-value">{{ totalAdmins }}</div>
          </div>
          <div class="c-content-row">
            <div>Operator</div>
            <div class="c-value">{{ totalOperators }}</div>
          </div>
          <div class="c-card-column-2">
            <div></div>
            <div class="c-content-row">
              <div>Receivers</div>
              <div class="c-value">{{ totalReceivers }}</div>
            </div>
          </div>
          <div class="c-card-column-2 c-bottom-content">
            <div>
              <button :disabled="isSuperAdminAndViewingUser" type="button" class="btn-blue-filled" :class="{ 'disabled-overlay': isSuperAdminAndViewingUser }" @click="ToggleAddUserPopup('buttonTrigger')">
                Add User</button>
            </div>
            <div class="c-content-row">
              <div>Total</div>
              <div class="c-value">{{ totalAdmins + totalOperators + totalReceivers }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="align-center justify-center admin-table">

    <div v-if="successMessage" class="message-delete-alert-con">
      <div class="alert alert-dismissible" :class="successMessage.includes('deleted') ? 'alert-delete' : 'alert-success'">
        <button type="button" class="close" @click="hideSuccessMessage" style="color:#828282">&times;</button>
        <span class="alert-headeing">Confirmation</span><br>
        {{ successMessage }}
      </div>
    </div>

    <div v-if="errorMessage" class="message-delete-alert-con">
      <div class="alert alert-dismissible alert-danger">
        <button type="button" class="close" @click="hideErrorMessage" style="color:#828282">&times;</button>
        <span class="alert-headeing">Error</span><br>
        {{ errorMessage }}
      </div>
    </div>

    <S2gTable @refresh="loadUsers" 
      @toggle-row-select="selectMessages"
      @select-all="selectAll"
      :indeterminate="indeterminate" :items="filteredUser"
      :selectedItemCount="selectedContacts" ref="tableRef" :isWhiteIcons="true" :headers="contactheader" 
      :filterItems="[
        { label: 'All', value: 'all' },
        { label: 'None', value: 'none' },
      ]"
       :thsearch="false" :showCount="true" :isReload="true"
      :totalItems="users.length ?? 0" :totalCountText="'Users'" :totalCountText1="'User'" :dynamicSearchHeight="false"
      :isSelectGlobalCheckBox="isSelectAll" :page="0" @column-filter="handleFilter">
      <!-- @column-filter="handleFilter" -->

      <template v-slot:table_body="{ item }">
        <td>
          <div>{{ item.item.name }}</div>
        </td>
        <td>
          <CheckCircle v-if="item.item.admin" />
          <!-- <SwitchSm v-model="item.item.admin" @update:modelValue="toggleAdminRole(item)" /> -->
        </td>
        <td>
          <CheckCircle v-if="item.item.operator" />
          <!-- <SwitchSm v-model="item.item.operator" @update:modelValue="toggleOperatorRole(item)" /> -->
          <!-- DEBUG: {{ item.item.operator }} -->
        </td>
        <td>
          <div style="width: 70px;" class="text-right">{{ item.item.receivers }}</div>
        </td>
        <td style="max-width: 150px; width: 150px">
          <div class="filter-cell" v-if="item.item.status == 'INVITED'">
            <ContactPending /> <span class="status-text">pending...</span>
          </div>
          <div class="filter-cell" v-if="item.item.status == 'ACCEPTED'">
            <ContactVerified /> <span class="status-text">active</span>
          </div>
          <div class="filter-cell" v-if="item.item.status == 'EXPIRE'">
            <UserPlus />
            <button @click="reinviteUser(item.item?.user)">
              <div class="invite-button">
                invite
              </div>
            </button>
          </div>
          <div class="filter-cell" v-if="item.item.status == 'NO ROLE'">
            <NavmenuProfileIcon /> <span class="status-text">no role</span>
          </div>
        </td>
        <td style="max-width: 200px; width: 200px; padding-left: 0;">
          <div class="table-actions" v-if="item.item.id != undefined">
            <!-- 3-dot menu icon -->
            <div class="setting-icon-wrapper">
              <UserDetails :item="item?.item?.user" @success="showSuccess" @error="showError" />
            </div>
            <!-- Back button when in monitoring mode, Eye icon otherwise -->
            <span v-if="currentUser?.AccountHolder" 
                  class="icon-btn" 
                  :class="{ 'disabled-overlay': ((item?.item?.id == accountHolder?.UserID || item?.item?.id == currentUser?.UserID) || !item?.item?.operator) && !$store.getters.isMonitoring }">
              <button v-if="$store.getters.isMonitoring && item?.item?.id == $store.getters.monitoringOperator?.UserID" @click="exitMonitoring" class="icon-action-btn" title="Exit Monitoring">
                <IconArrowBack />
              </button>
              <button v-else @click="((item?.item?.id == accountHolder?.UserID || item?.item?.id == currentUser?.UserID) || !item?.item?.operator) ? null : startMonitoringOperator(item.item?.user)" class="icon-action-btn" :title="(item?.item?.id == accountHolder?.UserID || item?.item?.id == currentUser?.UserID) ? 'Cannot monitor this user' : (item.item.status == 'NO ROLE' ? 'No role assigned' : (!item?.item?.operator ? 'Cannot monitor Only Admin' : 'Monitor User'))">
                <IconView />
              </button>
            </span>
            <span class="icon-btn" :class="{ 'disabled-overlay': isSuperAdminAndViewingUser }">
              <button @click="editUser(item?.item?.user)">
                <EditIcon />
              </button>
            </span>
            <span class="icon-btn" :class="{ 'disabled-overlay': isSuperAdminAndViewingUser || (currentUser?.UserID == item?.item?.id) || item?.item?.id == accountHolder?.UserID }">
              <button @click="(isSuperAdminAndViewingUser || (currentUser?.UserID == item?.item?.id) || item?.item?.id == accountHolder?.UserID) ? null : (deleteConfirmUser = item.item)">
                <IconArchieve />
              </button>
            </span>
          </div>
          <div class="table-actions" v-if="item.item?.user?.UserInvitationID">
            <span class="icon-btn" :class="{ 'disabled-overlay': isSuperAdminAndViewingUser }">
              <button @click="deleteConfirmInvitation = item.item">
                <DeleteIcon />
              </button>
            </span>
          </div>
        </td>
      </template>
    </S2gTable>
  </div>

  <AddUser v-if="addUserPopup.buttonTrigger" :forTransfer="isInviteModalOpenedForTransfer" @close="closeInviteModal" :source="editingUser ? 'edit' : 'add'"
    :editUser="editingUser" :title="addUserModalTitle" @success="showSuccess" @error="showError" @freetrialerror="showFreeTrialError"
    :TogglePopup="() => ToggleAddUserPopup('buttonTrigger')"
    @openInviteModal="()=>ToggleAddUserPopup('buttonTrigger')"
    >
  </AddUser>

  <OneOperatorAlert v-model="atLeastOneOperatorWarning" :close="closeOperatorAlert" />
  <OneAdminAlert v-model="atLeastOneAdminWarning" :close="closeAdminAlert" />

  <Confirmation v-model="deleteConfirmUser" :data="deleteConfirmUser" @closed="deleteConfirmUser = null"
    :onconfirm="(data) => deleteUser(data)" :body="'Do you really want to archive this user?'" />

  <Confirmation v-model="deleteConfirmInvitation" :data="deleteConfirmInvitation"
    @closed="deleteConfirmInvitation = null" :onconfirm="(data) => deleteInvitation(data)"
    :body="'Do you really want to delete this invitation?'" />

    <!-- Settings icon to be enabled later -->
    <!-- <AccountSettingsModal :showSettings="showSettingsModal" @closed="showSettingsModal = false" /> -->
    
    <AccountTransferModal @openInviteModal="openInviteModalForAccountTransfer" :show="isAccountTransferModal" @closed="isAccountTransferModal = false" />

  <AlertDialog v-model="adminFreeTrialError" @closed="adminFreeTrialError = false" title="Attention">
    <div>During this period of free usage, you can add up to two Admins.</div> <br>
    <div>To add more than two, activate your paid account now.</div> <br>
    <div>If you are not the Account Holder, request that they convert to a paid account.</div>
  </AlertDialog>

  <AlertDialog v-model="operatorFreeTrialError" @closed="operatorFreeTrialError = false" title="Attention">
    <div>During this period of free usage, you can add up to two Operators.</div> <br>
    <div>To add more than two, activate your paid account now.</div> <br>
    <div>If you are not the Account Holder, request that they convert to a paid account.</div>
  </AlertDialog>

</template>

<script setup>
import SwitchLg from '@/components/common/SwitchLg.vue';
import SwitchSm from '@/components/common/SwitchSm.vue';
import { ref, onMounted, onUnmounted, computed, reactive, watch } from 'vue';
import { useRouter } from 'vue-router';
import S2gTable from "@/components/common/S2gTable.vue";
import EditIcon from '@/components/icons/EditIcon';
import IconArchieve from '@/components/icons/IconArchieve';
import UserPlus from "@/components/icons/UserPlus.vue";
import ContactPending from "@/components/icons/ContactPending.vue";
import ContactVerified from "@/components/icons/ContactVerified.vue";
import UserDetails from '@/components/common/UserDetails.vue'
import AddUser from '@/components/AddUser.vue';
import userService from '@/services/userService';
import { useStore } from 'vuex';
import Confirmation from '@/components/modals/Confirmation.vue';
import OneOperatorAlert from '@/components/modals/OneOperatorAlert.vue';
import CheckCircle from '@/components/common/CheckCircle.vue';
import OneAdminAlert from '@/components/modals/OneAdminAlert.vue';
import NavmenuProfileIcon from '@/components/icons/NavmenuProfileIcon.vue';
import AccountSettingsModal from '@/components/modals/AccountSettingsModal.vue';
import IconSettings from '@/components/icons/IconSettings.vue';
import DeleteIcon from '@/components/icons/DeleteIcon.vue';
import IconDetails from '@/components/icons/IconDetails.vue';
import IconView from '@/components/icons/IconView.vue';
import IconArrowBack from '@/components/icons/IconArrowBack.vue';
import AlertDialog from '@/components/modals/AlertDialog.vue';
import { manageSelectedItems, manageSingleChecked, manageUnSelectedItems } from '@/helpers/s2gtable-helper';
import AccountTransferModal from '@/components/modals/AccountTransferModal.vue';
import { Utils } from '@/helpers/util';


const adminRoleSwitch = ref(false);
const operatorRoleSwitch = ref(false);
let successMessage = ref(null);
let errorMessage = ref(null);
let editingUser = ref(null);
let totalAdmins = ref(0);
let totalOperators = ref(0);
let totalReceivers = ref(0);
let users = ref([]);
let filteredUser = ref([]);
let operators = [];
let accountHolder = reactive({});
let deleteConfirmUser = ref(null);
let deleteConfirmInvitation = ref(null);
let atLeastOneOperatorWarning = ref(false);
let atLeastOneAdminWarning = ref(false);
const showSettingsModal = ref(false);
const isAccountTransferModal = ref(false);
const isPaymentMethodAdded = ref(false);
const adminFreeTrialError = ref(false);
const operatorFreeTrialError = ref(false);
const selectedMessages = ref([]);
const isSelectAll = ref(false);
const pager = ref({});
const isInviteModalOpenedForTransfer = ref(false);
const autoRefreshInterval = ref(null);
let store = useStore();
const router = useRouter();
let currentUser = computed(() => store.getters.user);

let isSuperAdminAndViewingUser = computed(() => {
  return store.getters.isOnBehalf;
})
let onBehalfUser = computed(() => {
  return store.getters.onBehalfUser;
})

// Resolve ClientID for API requests
const clientId = computed(() => {
  return store.getters.isOnBehalf
    ? store.getters.onBehalfUser?.ClientID
    : store.getters.user?.ClientID;
});

const addUserModalTitle = computed(() => {
  if (editingUser.value?.UserInvitationID) {
    return "Edit Invitation";
  } else if (editingUser.value) {
    return "User"
  } else {
    return "New User"
  }
});


const addUserPopup = ref({
  buttonTrigger: false
});
const ToggleAddUserPopup = (trigger, value) => {
  if(value==undefined) {
    addUserPopup.value[trigger] = !addUserPopup.value[trigger]
  } else {
    addUserPopup.value[trigger] = value;
  }
}

const handleFilter = (e) => {
  if (e?.column?.key == 'status') {
    if (e.e.value == 'all') {
      filteredUser.value = users.value;
    } else {
      filteredUser.value = users.value.filter(u => u.status == e?.e?.value);
    }
  }
};

const contactheader = [
  { key: "name", title: "Name", },
  { key: "admin", title: "Admin" },
  { key: "operator", title: "Operator" },
  { key: "receivers", title: "Receivers" },
  {
    key: "status",
    title: "Status",
    class: "pr-0",
    isFilter: true,
    filterItems: [
      { label: 'All', value: 'all' },
      { label: 'Pending', value: 'INVITED' },
      { label: 'Active', value: 'ACCEPTED' },
      { label: 'Expired', value: 'EXPIRED' },
    ],
  },
  { key: "details", title: "Details", class: "text-left" },
]
let indeterminate = false;

function selectMembers(e) {
}

function toggleProfilePopup() {
  dispatchEvent(new CustomEvent("toggleProfilePopup"))
}

async function editUser(user) {
  editingUser.value = user;
  // editingUser.value = await userService.getUserById(user.UserID);
  ToggleAddUserPopup("buttonTrigger");
}

const loadUsers = async () => {
  let clientId = isSuperAdminAndViewingUser.value ? onBehalfUser.value?.ClientID : null;
  let fetchedUsers = await userService.getAllUsers(clientId);
  console.log('🔍 [Admin.vue] Fetched users:', fetchedUsers);
  users.value = fetchedUsers.map(user => {
    console.log('🔍 [Admin.vue] Processing user:', user.FirstName, user.LastName, 'SaasOperator:', user.SaasOperator);
    return {
      id: user.UserID,
      name: `${user.FirstName} ${user.LastName}`,
      admin: !!user.SaasAdmin,
      operator: !!user.SaasOperator,
      receivers: user.receiver,
      status: user.Status,
      user: user
    }
  })
  filteredUser.value = users.value;
  operators = await userService.getFilteredOperators();
}

const loadUsersCount = async () => {
  let data = await userService.getUsersCount(clientId.value);
  totalAdmins.value = data.admin;
  totalOperators.value = data.operator;
  totalReceivers.value = data.receiver;
};

const showSuccess = (message, data) => {
  hideErrorMessage();
  editingUser.value = null
  if (data?.refresh) {
    loadUsers();
    loadUsersCount();
  }
  if (message) {
    successMessage.value = message;
    setTimeout(() => {
      hideSuccessMessage()
    }, 5000);
  }
}

const showError = (message) => {
  hideSuccessMessage();
  errorMessage.value = message;
  setTimeout(() => {
    hideErrorMessage()
  }, 5000);
}

const deleteUser = async (user) => {
  let userId = user.id;
  try {
    let res = await userService.deleteUser(userId);
    showSuccess("A user has been deleted.", { refresh: true });
  } catch (error) {
    if(error.type=="DEACTIVATED") {
      Utils.openAccountDeactivatedAlert(window, {context: "Users"})
    }
  }
  deleteConfirmUser.value = null;
}

const deleteInvitation = async (user) => {
  let invitationId = user?.user?.UserInvitationID;
  try {
    let res = await userService.deleteInvitation(invitationId);
    showSuccess("A user has been deleted.", { refresh: true });
  } catch (error) {
    // showError(error?.message);
    if(error.type=="DEACTIVATED") {
      Utils.openAccountDeactivatedAlert(window, {context: "Users"})
    }
  }
  deleteConfirmInvitation.value = null;
}

const updateUser = async (user, isAdmin) => {
  try {
    if (!Object.hasOwn(user, 'timezone')) {
      user.timezone = user.TimeZone;
    }
    console.log(user);
    let phone = user?.Phone ?? user?.PhoneNumber;
    let res = await userService.updateUser(user.FirstName,
      user.LastName, user.Email,
      phone, !!user.SaasAdmin, !!user.SaasOperator, user?.timezone, user?.UserID);
    // showSuccess(res?.message);
    if (user.UserID == currentUser.value?.UserID) {
      store.commit("setUser", user);
    }
    return null;
  } catch (error) {
    return error;
  }
}

const updateInvitation = async (user) => {
  try {
    let res = await userService.updateInvitation(user.FirstName,
      user.LastName, user.Email,
      user.Phone, !!user.SaasAdmin, !!user.SaasOperator, user?.UserInvitationID);
    // showSuccess(res?.message);
    return true;
  } catch (error) {
    // showError(error?.message);
    return false;
  }
}

const hideSuccessMessage = () => {
  successMessage.value = false;
}
const hideErrorMessage = () => {
  errorMessage.value = false;
}

const toggleAccountHolderRole = async (isAdmin) => {
  let error = await updateUser(accountHolder);
  if (error) {
    let isFreeTrialError = showFreeTrialError(error);
    if (isAdmin) {
      accountHolder.SaasAdmin = !accountHolder.SaasAdmin;
      atLeastOneAdminWarning.value = !isFreeTrialError;
    } else {
      accountHolder.SaasOperator = !accountHolder.SaasOperator;
      atLeastOneOperatorWarning.value = !isFreeTrialError;
    }
  }
}

function closeOperatorAlert() {
  atLeastOneOperatorWarning.value = false;
}

function closeAdminAlert() {
  atLeastOneAdminWarning.value = false;
}

const reinviteUser = async (user) => {
  try {
    let res = await userService.addUser(user.FirstName,
      user.LastName, user.Email,
      user.Phone, !!user.SaasAdmin, !!user.SaasOperator, user?.UserInvitationID);
    // showSuccess(res?.message);
    return true;
  } catch (error) {
    showFreeTrialError(error);
    // showError(error?.message);
    return false;
  }
}

const loadAccountHolder = async () => {
  let user = await userService.getAccountHolder(clientId.value);
  Object.assign(accountHolder, user);
  adminRoleSwitch.value = accountHolder?.SaasAdmin;
  operatorRoleSwitch.value = accountHolder?.SaasOperator;
}

async function openBilling() {
  let invoice = await userService.getBillingUrl();

  if (invoice && invoice.data) {
    window.open(invoice.data, '_blank');
  } else {
    console.error('Invoice data is unavailable.');
  }
}

async function loadPaymentMethodStatus() {
  let res = await userService.getFreeTrialStatus();
  isPaymentMethodAdded.value = res?.isPaymentMethod
}

function showFreeTrialError(res) {
  isInviteModalOpenedForTransfer.value = false;
  if(res?.type=="DEACTIVATED") {
    Utils.openAccountDeactivatedAlert(window, {context: "Users"})
    ToggleAddUserPopup("buttonTrigger", false);
    return true;
  }
  if (res?.type == 'FREE_TRIAL') {
    if (res?.code == 'admin') adminFreeTrialError.value = true;
    else if (res?.code == 'operator') operatorFreeTrialError.value = true;
    return true;
  }
  return false;
}


function selectAll(event) {
      // this.searchVisible = false;
      isSelectAll.value = event.target.checked;
      users.value = users.value.map((e) => {
        e.checked = event.target.checked;
        e.checkdClass = "";
        e.class = "hover_item";
        e.checkdClass = e.checked ? "member_selected" : "";
        return e;
      });
      // this.uncheckedMessages = [];
      // this.checkedMessages = [];
      // if (this.isSelectAll) {
      //   this.selectedMessages = this.pager.totalItems;
      //   this.checkedMessages = [];
      //   this.uncheckedMessages = [];
      //   this.indeterminate = false;
      // } else {
      //   this.selectedMessages = 0;
      //   this.indeterminate = false;
      }


function selectMessages(e) {
    const event = e.e;
    console.log(e.item);
    // this.indeterminate = false;
    // this.searchVisible = false;
    const u = manageSingleChecked(
      event,
      e.item,
      "ContentID",
      users.value,
      selectedMessages.value,
      isSelectAll.value,
      pager.value?.totalItems
    );
    console.log(u);
    this.selectedMessages = Number(u.selectedCounts);
    this.isSelectAll = u.isSelectAll;
    this.indeterminate = u.indeterminate;
    if (event.target.checked) {
      e.item.checked = event.target.checked;
    } else {
      // if (this.isSelectAll) {
      //   this.indeterminate = true;
      // }
    }
    
    manageSelectedItems(event, e.item, "ContentID", this.checkedMessages);
    manageUnSelectedItems(event, e.item, "ContentID", this.uncheckedMessages);
    manageGlobalSelection();
    this.ourcontents = this.ourcontents.map((e) => {
      e.checkdClass = "";
      if (e.checked) {
        e.checkdClass = "member_selected";
      }
      e.class = "hover_item";
      return e;
    });
  }

  function manageGlobalSelection() {
      //const checkedCount = this.users.filter((e) => e.checked).length;

      if (this.selectedMessages > 0) {
        if (this.selectedMessages == this.pager.totalItems) {
          this.isSelectAll = true;
          this.selectedMessages = this.pager.totalItems;
          this.indeterminate = false;
        } else if (!this.isSelectAll) {
          this.indeterminate = true;
        }
      } else {
        this.indeterminate = false;
        this.isSelectAll = false;
      }
    }

    function openInviteModalForAccountTransfer(){
      ToggleAddUserPopup('buttonTrigger')
      isInviteModalOpenedForTransfer.value = true;
    }

    function closeInviteModal(){
      editingUser.value = null;
    }

    // Start monitoring operator (Account Holder feature)
    function startMonitoringOperator(operator) {
      // Set monitoring state in Vuex (similar to onBehalf for Super Admin)
      store.commit('setMonitoringOperator', {
        UserID: operator.UserID,
        FirstName: operator.FirstName,
        LastName: operator.LastName,
        ClientID: operator.ClientID,
        SaasAdmin: !!operator.SaasAdmin,
        SaasOperator: !!operator.SaasOperator,
        Email: operator.Email,
        PhoneNumber: operator.PhoneNumber || operator.Phone,
        TimeZone: operator.TimeZone || operator.timezone
      });
      
        // If the user has an Operator role, navigate to activity page via SPA navigation.
      // If they are only an Admin, stay on the Admin page — reactive state update is enough.
      if (operator.SaasOperator) {
        router.push('/activity');
      }
    }

    // Exit monitoring mode — just clear state; template reacts to $store.getters.isMonitoring
    function exitMonitoring() {
      store.commit('clearMonitoring');
    }

onMounted(() => {
  // Clear any lingering monitoring state — router.beforeEach handles this for SPA nav,
  // the IIFE in main.js handles full reloads, but clear here as a safety net.
  if (store.getters.isMonitoring) {
    store.commit('clearMonitoring');
  }
  loadUsers();
  // Load counts once clientId is available; fallback to immediate if already present
  if (clientId.value) {
    loadUsersCount();
  }
  loadAccountHolder();
  loadPaymentMethodStatus();

  // Set up auto-refresh every 30 seconds
  autoRefreshInterval.value = setInterval(() => {
    loadUsers();
    if (clientId.value) {
      loadUsersCount();
    }
  }, 30000); // 30 seconds
});

// Re-fetch counts when clientId becomes available or changes (on-behalf switch)
watch(clientId, (val, oldVal) => {
  if (val && val !== oldVal) {
    loadUsersCount();
  }
});

// Clean up interval on component unmount
onUnmounted(() => {
  if (autoRefreshInterval.value) {
    clearInterval(autoRefreshInterval.value);
  }
});


</script>

<style lang="scss" scoped>
.c-card-right-btn {
  position: absolute;
}

.alert-dismissible {
  margin-bottom: 12px;
}

.alert-delete {
  background: #F5E0AB !important;
}


.c-card-group {
  display: grid;
  grid-template-columns: 1fr 440px;
  column-gap: 60px;
}

.c-card-column-4 {
  display: grid;
  grid-template-columns: 266fr 272fr 202fr auto;
}

.c-card-column-3 {
  display: grid;
  grid-template-columns: 266fr 272fr 202fr;
}

.c-card-column-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
}

.content-type-1 {
  font-size: 16px;
  line-height: 20px;
  margin-top: 20px;

  & .btn-group {
    margin-top: 41px;
    display: flex;
    flex-direction: column;
    gap: 22px;
  }
}

.c-content-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 0;
  border-bottom: 1px solid #E0E0E0;
  line-height: 20px;

  & .c-value {
    font-size: 24px;
    line-height: 20px;
  }
}

.c-bottom-content {
  margin-top: auto;

  & .c-content-row {
    height: 36px;
    border-bottom: none;
  }
}

.switch-group {
  margin-top: 20px;
  display: flex;
  align-items: center;
  gap: 14px;
}

.c-card {
  background-color: #fff;
  padding: 33px 30px 20px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  position: relative;

  & .c-card-title {
    font-size: 16px;
    line-height: 16px;
    color: #000;
    padding-bottom: 16px;
    border-bottom: 1px solid #E0E0E0;
    font-weight: 500;
  }

  & .c-card-item {
    display: flex;
    flex-direction: column;
    flex: 1;

    & .c-card-content {
      display: flex;
      flex-direction: column;
      flex: 1;

      & ul {
        list-style-type: none;
        padding: 0;
        margin: 0;
        display: flex;
        flex-direction: column;
        gap: 10px;
      }
    }
  }
}

.btn-outline {
  display: flex;
  width: 100px;
  // padding-block: 5px;
  height: 30px;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: 1px solid #7B8794;
  border-radius: 5px;
  font-size: 16px;
  line-height: 20px;
  cursor: pointer;
  color: #000;
  transition: 0.2s all ease;

  &:hover {
    background-color: #F2F2F2;
  }
}

.btn-blue-filled {
  display: flex;
  min-width: 100px;
  height: 36px;
  align-items: center;
  padding: 0 17px;
  justify-content: center;
  text-align: center;
  border-radius: 3px;
  font-size: 14px;
  line-height: 16.41px;
  cursor: pointer;
  color: #fff;
  background-color: #4066CF;
  text-transform: uppercase;
  font-weight: 500;
  transition: 0.2s all ease;

  &:hover {
    background-color: #6B87D4;
  }
}

.status-text {
  font-size: 13px;
  line-height: 16px;
  color: #333333;
  font-weight: 500;
}

.admin-table {
  margin-top: 26px;
  margin-bottom: 60px;
}

.invite-button {
  width: 50px;
  height: 20px;
  background: #7B8794;
  font-size: 13px;
  line-height: 16px;
  color: #F2F2F2;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
}

.disabled-overlay {
  pointer-events: none;
  opacity: 0.3;
}

.unclickable {
  pointer-events: none;
}

.icon-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  width: 30px;
  height: 30px;
  transition: 0.2s all ease;

  &:hover {
    background-color: #ffffff !important;
    border-radius: 8px !important;
  }
}

// Override mr-70 to mr-110 (116px) for admin table headers
.admin-table :deep(.mr-70) {
  margin-right: 120px !important;
}

.table-actions .icon-btn:hover, 
.table-actions .icon-btn button:hover,
.table-actions .icon-action-btn:hover {
  background-color: #ffffff !important;
  border-radius: 8px !important;
}
</style>

